import { render, staticRenderFns } from "./SendOrderConfirmation.vue?vue&type=template&id=304d80a8"
import script from "./SendOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./SendOrderConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports